import script from "./PieChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./PieChart.vue?vue&type=script&lang=ts&setup=true"

import "./PieChart.vue?vue&type=style&index=0&id=490309f4&lang=scss"

const __exports__ = script;

export default __exports__